export class Products {
    id: number;
    productCode: string;
    productName: string;
    productDescription: string;
    price: number;
    unitsPerCase: number;
    outOfStock: boolean;
    productCategory: string;
    productCategoryId: number;
    quantity : number;
    productImage : string;
}
